import React from 'react';
import FixedView from '../../FixedView';
import Responsive from '../../Responsive';
import Calendar from '../Calendar';
import NewTask from './newTask';
import { v4 as uuidv4 } from "uuid";
import TaskItem from './TaskItem';
import moment from 'jalali-moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import { checkTranslation, chooseWallpaper, conditionalWidth, imageAddress, playSound, translate } from "../../../utils/useful";
import TaskDetails from './taskDetail';


const WeeksName =
    [
        'son',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ]
const MonthsName =
    [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
const YearsName =
    [
        '2022',
        '2021',
        '2020',
        '1999',
        '1998',
        '1997',
        '1996',
    ]

export default class WeeklySchedule extends React.Component {
    state = {
        Calendar: new Calendar(),
        newTask: false,
        addTask: false,
        name: "name",
        currentItem: "",
        Tasks: [],
        selectedDay: "",
        weekends: false,
        detail: false,
        status: "",
        link: "",
        priority: "",
    }
    setNewTask = () => {

        // console.log("setnewtask", this.state.newTask)
        this.setState({ newTask: !this.state.newTask })

    }
    getWeekTasks(week, cToday) {
        let weekTasks = {};
        // console.log(cToday)
        const { Tasks } = this.state;
        // console.log('in getWeekTasks')
        // console.log(Tasks)
        week.forEach(day => {
            cToday.day = day;
            //find all task with taskDate === cToday;
            // console.log(this.toUnixTime(cToday))
            weekTasks[day] = Tasks.filter(task => task.taskDate === this.toUnixTime(cToday))
        });
        return weekTasks
    }

    toUnixTime(cToday) {
        const { year, month, day } = cToday;
        return moment(`${year}-${month}-${day}`, 'YYYY-MM-DD').unix()
    }
    addTask = (newName, date, color) => {
        // console.log('heare in add Task')
        const { Tasks } = this.state;
        let oldTasks = [...Tasks]
        let newTask = {
            taskId: uuidv4(),
            taskName: newName,
            taskDate: this.toUnixTime(date),
            taskColor: color
        };
        oldTasks.push(newTask)
        this.setState({ Tasks: oldTasks, addTask: true, newTask: false })
    }
    renameTask = (name, id) => {
        // console.log("rename")
        const { Tasks } = this.state;
        let oldTasks = [...Tasks]
        let renameTask = Tasks.find(task => task.taskId === id)
        renameTask.taskName = name;
        this.setState({ Tasks: oldTasks });
    }
    removeTask = (taskName, date, color) => {
        const { Tasks } = this.state;
        let oldTasks = [...Tasks]
        let removedTask = Tasks.find(task => task.taskName === taskName && task.taskId)
        oldTasks.pop(removedTask)
        this.setState({ Tasks: oldTasks, addTask: true, removedTask: false })
        // console.log(Tasks, "here")
    }
    showMonthList = () => {
        this.monthView.showView()
    }

    showYearList = () => {
        this.yearView.showView()
    }

    showWeekend = () => {
        this.setState({ weekends: !this.state.weekends })
    }
    getStatus(status) {
        console.log(status)
        if (status)
            this.setState({ status: "Complete" })
        else
            this.setState({ status: "inComplete" })


    }
    getPriority(priority) {
        console.log(priority)
        // this.setState({ priority: priority })
        console.log(this.state.priority)

    }
    showDetail = (show) => {
        if (show) {
            this.setState({ detail: show })
        }
    }
    selectDay = (year, month, day) => {
        let newDate = moment.utc();
        newDate.set('year', year);
        newDate.set('month', month);
        newDate.set('date', day);
        // console.log(newDate.format('YYYY MM DD'), "newdateeeee");
        this.setState({ selectedDay: newDate.format('YYYY MM DD') })
    }

    render() {
        const { calender } = this.state;
        const { weekends } = this.state;
        const week = calender.getWeek();
        const rToday = calender.getToday(); // real today
        let cToday = { year: calender.toMoment().format('YYYY'), month: calender.toMoment().format('MM'), day: 0 } // calenderToday
        let weekTasks = this.getWeekTasks(week, cToday);
        const newWeek = !weekends ? week : week.slice(1, 6);
        // console.log(JSON.stringify(weekTasks))
        return (
            <Responsive height="100%" width={this.props.width} media={{ xs: this.state.leftSideBarStage == true ? "12" : 'none', sm: '3', md: '3', lg: "2", xl: "2" }}>
                <div id="color" className='weekly-calendar w-100   ' style={{ background: '#fff', borderRadius: 15 }} >
                    <div className="d-flex justify-content-between p-3 w-100">

                        <div className="d-flex weekly-nav">

                            <button onClick={() => {
                                calender.goToPrev('month')
                                this.setState(
                                    {
                                        calender
                                    }
                                )
                            }}>
                                <img src="/assets/icons/control.svg " alt='back'
                                    style={{
                                        transform: "rotate(-90deg)",
                                        opacity: "50%"
                                    }}
                                />

                            </button>
                            <p className='cursor-pointer text-center  my-1 px-2 br-5' style={{ minWidth: "110px" }} onClick={() => this.showMonthList()} ref={el => this.monthCurrentNode = el}>  {calender.toMoment().format('MMMM')}
                            </p>
                            <button onClick={() => {
                                calender.goToNext('month')
                                this.setState(
                                    {
                                        calender
                                    }
                                )
                            }}>
                                <img src="/assets/icons/control.svg " alt='next'
                                    style={{
                                        transform: "rotate(90deg)",
                                        opacity: "50%"
                                    }}
                                />

                            </button>&nbsp;

                            <p className='cursor-pointer text-center px-2 flexc my-1 br-5' style={{ minWidth: "70px" }} onClick={() => this.showYearList} ref={el => this.yearCurrentNode = el} > {calender.toMoment().format('YYYY')}
                            </p>&nbsp;&nbsp;

                            <p className='cursor-pointer text-center font-size-13 px-2 flexc my-1 br-5' style={{ padding: "5px", background: "#5B42F3", color: "white" }} onClick={() => this.state.calender.goToday()}>
                                Today
                            </p>

                            <p className='cursor-pointer text-center font-size-13 mld-3  px-2 flexc my-1 br-5' style={{ background: "#5B42F3", color: "white" }} onClick={() => this.showWeekend()}>
                                Weekends : {this.state.weekends ? "off" : "on"}
                            </p>
                        </div>

                        <div className="d-flex align-content-center">
                            <button onClick={() => {
                                calender.goToPrev('week')
                                this.setState({
                                    calender
                                })
                            }}>
                                <img src="/assets/icons/arrowtriangle.left.circle.fill.svg" alt='back'
                                    style={{
                                        opacity: "50%"
                                    }} />

                            </button>&nbsp;
                            <button onClick={() => {
                                calender.goToNext('week');
                                this.setState({
                                    calender
                                })
                            }}>
                                <img src="/assets/icons/arrowtriangle.right.circle.fill.svg" alt='next'
                                    style={{
                                        opacity: "50%"
                                    }} />
                            </button>

                        </div>
                    </div>
                    <FixedView ref={el => this.monthView = el} nodeRef={this.monthCurrentNode} topOffset={0} xOffset={-5} zIndex={10} >
                        <div className='shadow-2 br-10 py-1 px-2 text-center scroll-no-scrollbar' style={{ backgroundColor: "#fff", width: "120px", maxHeight: "200px" }} >

                            {MonthsName.map((month, index) => {
                                return (
                                    <div
                                        onClick={() => {
                                            calender.setMonth(index + 1)
                                            this.setState({
                                                calender
                                            })
                                        }}
                                        className='cursor-pointer px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5'
                                    >{month}</div>
                                )
                            })}
                        </div>
                    </FixedView >
                    <FixedView ref={el => this.yearView = el} nodeRef={this.yearCurrentNode} topOffset={0} xOffset={-25} zIndex={100}>
                        <div className='shadow-2 br-10 py-1 px-2 text-center' style={{ backgroundColor: "white", width: "70px" }} >
                            {YearsName.map((year, index) => {

                                return (
                                    <div
                                        onClick={() => {
                                            calender.setYear(year)
                                            this.yearView.hideView()
                                            this.setState({
                                                calender
                                            })
                                        }}
                                        className='cursor-pointer px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5'
                                    >{year}</div>
                                )
                            })}
                        </div>
                    </FixedView>

                    <div className="" style={{ padding: "0 2%" }}>

                        <div className='week-map ' style={{ display: "flex", flexDirection: "row" }}>
                            {newWeek.map((day, index) => {
                                cToday.day = day;
                                // console.log(this.state.selectedDay, index, "selectedday")

                                const isToday = (cToday.year === rToday.year) && (cToday.day === rToday.day) && (cToday.month === rToday.month);
                                return (

                                    <div key={index} className='br-8 mld-2' style={{ height: "fit-content", background: "white", border: ".1px solid  rgb(169 169 169 / 42%)", padding: "7px", minWidth: !this.state.weekends ? "13.6%" : "19%" }}>
                                        <div className="week-day br-8 mb-2"
                                            onClick={() => this.selectDay(cToday.year, cToday.month, day)}
                                            style={{
                                                border: "", boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px 0px",
                                                alignItems: 'center', background: isToday ? '#5B42F3' : 'rgb(204 204 204 / 20%)', padding: "5px", height: "fit-content"

                                            }}>
                                            <div className='' style={{ padding: 5, display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
                                                <div>
                                                    <p style={{ fontSize: 15, color: isToday ? '#fff' : '#000' }}>
                                                        {!this.state.weekends ?
                                                            WeeksName[index]
                                                            :
                                                            WeeksName.slice(1, 6)[index]
                                                        }</p>
                                                </div>
                                                <div>
                                                    <p style={{ color: isToday ? '#fff' : '#000' }}>{day}</p>
                                                </div>
                                            </div>
                                        </div>

                                        {this.state.addTask ?

                                            <>
                                                {weekTasks[day].map((item, index) => {
                                                    const { taskId, taskName, taskDate, taskColor, taskLink } = item;
                                                    return (
                                                        <div>
                                                            <TaskItem
                                                                taskId={taskId}
                                                                taskColor={taskColor}
                                                                taskDate={taskDate}
                                                                key={taskId}
                                                                name={taskName}
                                                                index={index}
                                                                showDetail={this.showDetail}
                                                                removeTask={this.removeTask}
                                                                renameTask={this.renameTask}
                                                                addTask={this.state.addTask}
                                                                getPriority={this.getPriority}
                                                                getStatus={this.getStatus}
                                                            />

                                                            {this.state.detail &&
                                                                <div className={"sidePanel h-100  "} style={{ background: "white", zIndex: 20, maxWidth: 300, width: "250px" }} >
                                                                    <div className='sidePanel-content h-100 blur-back' >

                                                                        <TaskDetails
                                                                            taskId={taskId}
                                                                            taskColor={taskColor}
                                                                            taskDate={taskDate}
                                                                            key={taskId}
                                                                            name={taskName}
                                                                            taskPriority={this.state.priority}
                                                                            taskStatus={this.state.status}
                                                                        />
                                                                        {console.log("in return ", this.state.status, this.state.priority)}

                                                                        <button className={"close-hide sideHandler blur-back flexcc "} onClick={() => this.setState({ detail: false })}>
                                                                            <img src="/images/next-2.png" width="25px" alt="" />
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                            }
                                                        </div>

                                                    )
                                                })
                                                }
                                            </>
                                            :
                                            ""}
                                        <NewTask addTask={this.addTask} setNewTask={this.setNewTask} date={{ ...cToday }} />
                                    </div>
                                )
                            })}

                        </div>
                    </div>

                </div>
            </Responsive>
        )
    }
}
